'use strict';

var Sugar = require('sugar-core');

require('./build/buildDateUnitMethodsCall');

module.exports = Sugar.Date.daysSince;


// WEBPACK FOOTER //
// ./~/sugar-date/date/daysSince.js